import React from 'react';
import ReactDOM from 'react-dom/client';
import { Router } from 'react-router-dom';
import history from 'services/create-history';
import { Provider } from 'react-redux';
import { store, persistor } from 'store';
import { ThemeProvider as KisThemeProvider, StyleBase } from '@kistech/kis-ui';
import { createTheme, ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import * as serviceWorker from './serviceWorker';
import Routes from 'routes';
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const theme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        stickyHeader: {
          backgroundColor: '#fafafa'
        }
      }
    }
  }
});

root.render(
  <>
    <StyleBase />
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router history={history}>
          <StyledEngineProvider injectFirst>
            {/* KisThemeProvider should wrap MuiThemeProvider so Kis UI takes priority */}
            <KisThemeProvider
              theme={{
                palette: {
                  primary: '#f46d2e',
                  secondary: '#222930'
                },
                fonts: {
                  primary: 'Poppins, sans-serif'
                }
              }}
            >
              <MuiThemeProvider theme={theme}>
                <Routes />
              </MuiThemeProvider>
            </KisThemeProvider>
          </StyledEngineProvider>
        </Router>
      </PersistGate>
    </Provider>
  </>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
